export default __webpack_public_path__ + "static/media/background.9a1b63f4.png";